import React from 'react';
import FormField from '../../steps/FormField';
import InfoIcon from '../../../assets/svgs/info.svg';

interface ZipCodeFieldProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const ZipCodeField: React.FC<ZipCodeFieldProps> = ({ value, onChange }) => {
  return (
    <FormField
      name="zipCode"
      label="Zip code"
      placeholder="Enter Zip code"
      value={value}
      onChange={onChange}
      onBlur={() => {}}
      type="tel"
      autoComplete="postal-code"
    />
  );
};

export default ZipCodeField;